import { useEffect, useState } from "react";
import { t } from "i18next";
import { ReactComponent as EmptyStateImage } from "../../../images/noCalendar.svg";
import JourneyCatchUpItem from "./JourneyCatchUpItem";
import { DashboardJourneyTabType } from "../../../types/dtos/dashboards/DashboardJourneyTabType";
import YourJourneyCatchUpDto from "../../../types/dtos/catch-ups/YourJourneyCatchUpDto";
import PaginationControls from "../../common/PaginationControls";

interface JourneyCatchUpTabProps {
  currentUserId: number;
  catchUps: YourJourneyCatchUpDto[];
  selectedTab: DashboardJourneyTabType;
  onCancelCatchUp?: (answerSetGuidId: string) => void;
}

export const JourneyCatchUpTab = ({
  currentUserId,
  catchUps,
  selectedTab,
  onCancelCatchUp,
}: JourneyCatchUpTabProps) => {
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalItemCount, setTotalItemCount] = useState<number>(catchUps.length);
  const [itemsOnDisplay, setItemsOnDisplay] = useState<YourJourneyCatchUpDto[]>(
    []
  );

  const isCompletedTab = selectedTab === "COMPLETED";

  useEffect(() => {
    // Set the page number to 1 when the forms change
    const pageNum = 1;
    setPageNumber(pageNum);
    calculateItemsToDisplay(pageNum);
    setTotalItemCount(catchUps.length);
  }, [catchUps]);

  const handlePageNumberChange = (pageNumber: number) => {
    setPageNumber(pageNumber);
    calculateItemsToDisplay(pageNumber);
  };

  const handlePageSizeChange = (pageSize: number) => {
    setItemsPerPage(pageSize);
    // Reset to page 1 when changing page size
    setPageNumber(1);
    // Pass the new page size directly to avoid race condition with state updates
    calculateItemsToDisplay(1, pageSize);
  };

  const calculateItemsToDisplay = (
    newPageNumber: number,
    newPageSize?: number
  ) => {
    const pageSize = newPageSize || itemsPerPage;
    var startIndex = (newPageNumber - 1) * pageSize;
    let displayItems = [...catchUps].splice(startIndex, pageSize);
    setItemsOnDisplay(displayItems);
  };

  return (
    <>
      {catchUps.length === 0 && (
        <div className="pt-4 lg:pt-16 text-center text-gray-400">
          <div className="flex justify-center">
            <EmptyStateImage className="max-w-1/2" />
          </div>
          <p className="pt-2 lg:pt-4 text-sm">
            {t("Pages.MyDashboard.CatchUps.EmptyState")}
          </p>
        </div>
      )}

      {catchUps.length > 0 && (
        <>
          <div className="mt-4">
            {itemsOnDisplay.map((catchUp) => (
              <JourneyCatchUpItem
                key={`form_item_${catchUp.answerSetGuidId}`}
                catchUp={catchUp}
                isCompletedTab={isCompletedTab}
                currentUserId={currentUserId}
                onCancelCatchUp={onCancelCatchUp}
              />
            ))}
          </div>

          <PaginationControls
            activePage={pageNumber}
            itemsPerPage={itemsPerPage}
            totalItemCount={totalItemCount}
            onPageChange={handlePageNumberChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </>
      )}
    </>
  );
};
